import * as React from "react";
import { useLocation, useParams } from "react-router-dom";
import { PaymentRouteParams } from "../../constants/types";
import useLayanan from "../../services/queries/useLayanan";
import useVoucher from "../../services/queries/useVoucher";
import useUkm from "../../services/queries/useUkm";

export default function usePaymentOrderDetails() {
    const { layananId, ukmId } = useParams<PaymentRouteParams>();
    const location = useLocation();
    const searchParams = React.useMemo(
        () => new URLSearchParams(location.search),
        [location.search],
    );
    const voucherIdParam = searchParams.get("voucherId");
    const parsedVoucherId = voucherIdParam ? Number(voucherIdParam) : undefined;
    const voucherId =
        parsedVoucherId !== undefined && Number.isFinite(parsedVoucherId)
            ? parsedVoucherId
            : undefined;

    const typeParam = searchParams.get("type");
    const isNaikKelasFromUrl = typeParam === "naik-kelas";

    const ukmParams = React.useMemo(
        () => ({ size: 500, page: 1, search: "" }),
        [],
    );
    const { data: ukmList, status: ukmStatus } = useUkm(ukmParams);
    const currentUkm = React.useMemo(
        () =>
            ukmId
                ? ukmList?.content?.find(
                      (item) => Number(item.id) === Number(ukmId),
                  )
                : undefined,
        [ukmList, ukmId],
    );
    
    const isNaikKelas = isNaikKelasFromUrl || (currentUkm?.isNaikKelas === 1);

    const { data: layanan, status: layananStatus } = useLayanan(
        currentUkm ? { isNaikKelas } : undefined,
    );
    const { data: vouchers, status: voucherStatus } = useVoucher({
        ukmId: voucherId ? Number(ukmId) : undefined,
    });

    const selectedLayanan = layanan?.find(
        (item) => item.id.toString() === layananId,
    );
    const selectedVoucher = vouchers?.find((item) => item.id === voucherId);
    const discount = Math.min(
        selectedVoucher?.nominal ?? 0,
        selectedLayanan?.harga ?? 0,
    );
    const totalPrice = Math.max((selectedLayanan?.harga ?? 0) - discount, 0);

    return {
        discount,
        isLoading:
            ukmStatus === "loading" ||
            !currentUkm ||
            layananStatus === "loading" ||
            (Boolean(voucherId) && voucherStatus === "loading"),
        isNaikKelas,
        search: location.search,
        selectedLayanan,
        selectedVoucher,
        totalPrice,
        voucherId,
    };
}